export default "__VITE_ASSET__ZfoUaYtx__"